/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { InputCana } from "./modelInputCana";

class ControllerInputCana extends ControllerModel {
  constructor() {
    super("ControllerInputCana");
    
    this.setNewNode = (callback) => {
      let inputCana = new InputCana();
      inputCana.decorate(callback);

      this.addNode(inputCana);
      SingletonFlowchart.SaveStatus()
    }

    this.loadNode = (node, callback) => {
      let inputCana = new InputCana();
      inputCana.copyFrom(node);
      inputCana.decorate(callback);
      this.addNode(inputCana)
    }

    this.getProperties = async (node) => {
      let n = new InputCana();
      await n.copyFrom(node);
      return n.data
    }

    this.getNode = (node) => {
      let n = new InputCana();
      n.copyFrom(node);
      return n
    }
  }
}

export { ControllerInputCana };
